import { StyleSheet } from 'react-native';
import { LI } from '@expo/html-elements';
import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsNutritionEntriesItem = (props: Props) => {
  const { title, value } = props;

  return (
    <LI style={styles.container}>
      <BodyText>{title}</BodyText>
      <BodyText>{value}</BodyText>
    </LI>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: theme.spacing['2'],
    justifyContent: 'space-between',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  title: string;
  value: string | number;
};
